<template>
    <el-dialog
        :title="title"
        :visible.sync="display"
        :append-to-body="true"
        width="60%"
    >
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-width="180px"
        >
            <el-form-item :label="getVerbose('permissions_role_creation_form_label_name')">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item :label="getVerbose('permissions_role_creation_form_label_users')">
                <el-transfer
                    v-model="form.users_uid"
                    :data="userList"
                    :titles="[getVerbose('permissions_role_creation_form_transfer_left_label'), getVerbose('permissions_role_creation_form_transfer_right_label')]"
                    :props="{
                        key: 'uid',
                        label: 'email'
                    }"
                ></el-transfer>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button @click="display = false">{{ getVerbose('permissions_role_creation_button_cancel') }}</el-button>
            <el-button type="primary" @click="save">{{ getVerbose('permissions_role_creation_button_save') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {mapGetters} from 'vuex';
export default {

    components: {

    },

    props: {
        userList: {
            type: Array,
            required: true,
        }
    },

    data (){
        return {
            display: false,
            form: {
                name: '',
                users_uid: [],
            },
            title: '',
            rules: {name: [{required: true}]},
        };
    },

    computed: {
        ...mapGetters('fundation', [
            'getVerbose'
        ])
    },

    mounted() {
        this.title = this.getVerbose('permissions_role_creation_form_title');
    },

    methods: {
        init (role=null){
            if(role){
                this.$set(this, 'form', JSON.parse(JSON.stringify(role)));
                this.title = this.getVerbose('permissions_role_creation_form_title_edit');
            }else{
                this.$set(this, 'form', {name: '', users_uid: []});
            }
            this.display = true;
        },
        close (){
            this.display = false;
        },
        save (){
            this.$refs.form.validate((valid) => {
                if(valid){
                    this.$emit('save-role', this.form);
                }
            });
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/permissionsManagement/role-modale.vue